"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basketQueries = exports.basketQueryKeys = void 0;
const basket_api_1 = require("./basket.api");
exports.basketQueryKeys = {
    all: () => ['basket'],
    getBasketBasic: () => [...exports.basketQueryKeys.all(), 'basketBasic'],
};
const basketQueries = (apiOptions) => ({
    getBasketBasic: (options = {}) => (Object.assign(Object.assign({}, options), { queryKey: exports.basketQueryKeys.getBasketBasic(), queryFn: (context) => (0, basket_api_1.getBasketBasic)(apiOptions, context) })),
});
exports.basketQueries = basketQueries;
//# sourceMappingURL=basket.queries.js.map